import { useState } from "react";

export default function PanelArray({ sizing }) {
  const { pv, inverter, battery } = sizing;
  const [hover, setHover] = useState(null);
  const count = pv.count;
  const cols = count <= 8 ? 4 : count <= 18 ? 6 : 8;
  const rows = Math.max(1, Math.ceil(count / cols));
  const cells = rows * cols;
  const p = pv.panel;

  return (
    <div className="kl-panel-dark p-6 kl-grid-bg" data-testid="panel-array">
      <div className="flex items-start justify-between mb-5">
        <div><p className="kl-label-dark">Virtual array</p><h3 className="font-display font-light text-2xl mt-1">{count} × {p?.rating ?? 0} W · {pv.array_kw} kWp</h3></div>
        <div className="text-right font-mono text-xs text-kl-muted">
          <div>{rows} rows × {cols} cols</div>
          <div>{pv.roof_area_m2} m² footprint</div>
        </div>
      </div>

      <div className="flex gap-6 items-start">
        <div className="flex-1 border border-kl-line p-3 bg-kl-black/60">
          <div className="grid gap-1.5" style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}>
            {Array.from({ length: cells }).map((_, i) => {
              const real = i < count;
              return (
                <div key={i} data-testid={real ? `panel-cell-${i}` : undefined} onMouseEnter={() => real && setHover(i)} onMouseLeave={() => setHover(null)}
                  className={`kl-panel-cell aspect-[1134/2278] max-h-24 ${real ? "" : "ghost"} ${hover === i ? "!border-kl-green" : ""}`} style={{ animation: real ? `rise .3s ease-out ${i * 25}ms both` : "none" }}>
                  {real && <span className="absolute bottom-1 right-1 font-mono text-[9px] text-kl-muted">{String(i + 1).padStart(2, "0")}</span>}
                </div>
              );
            })}
          </div>
        </div>
        <div className="w-56 shrink-0 space-y-3" data-testid="panel-spec">
          <div className="border border-kl-line p-3 bg-kl-black">
            <div className="kl-label-dark">{hover != null ? `Panel ${String(hover + 1).padStart(2, "0")}` : "Module"}</div>
            <div className="font-display text-sm mt-1">{p?.brand} {p?.model || "—"}</div>
            <dl className="mt-2 font-mono text-[11px] text-kl-muted space-y-1">
              <div className="flex justify-between"><dt>Pmax</dt><dd className="text-white">{p?.rating ?? 0} W</dd></div>
              <div className="flex justify-between"><dt>Efficiency</dt><dd className="text-white">{p?.efficiency ?? "—"} %</dd></div>
              <div className="flex justify-between"><dt>Size</dt><dd className="text-white">{p?.width_mm ?? "—"} × {p?.height_mm ?? "—"} mm</dd></div>
            </dl>
          </div>
          <div className="border border-kl-line p-3 bg-kl-black">
            <div className="kl-label-dark">Inverter</div>
            <div className="font-mono text-xs mt-1">{inverter.count} × {inverter.recommended?.model || "—"}</div>
            <div className="kl-label-dark mt-3">Storage</div>
            <div className="font-mono text-xs mt-1">{battery.count} × {battery.recommended?.model || "—"}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
